export const searchFieldsForParams = ['category', 'subcategory', 'app', 'rubric', 'query']
